var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "white",
    stroke: "#FFAA04"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12.0075 18C12.8359 18 13.5075 17.3284 13.5075 16.5C13.5075 15.6716 12.8359 15 12.0075 15C11.1791 15 10.5075 15.6716 10.5075 16.5C10.5075 17.3284 11.1791 18 12.0075 18ZM12.1125 13.5C12.8925 13.5 13.5525 12.9 13.6125 12.105L13.9425 7.605C14.0025 6.735 13.3125 6 12.4425 6H11.5575C10.6875 6 9.9975 6.735 10.0575 7.605L10.3875 12.105C10.4475 12.9 11.1075 13.5 11.8875 13.5H12.1125Z",
    fill: "#FFAA04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewErrorIcon);
export default __webpack_public_path__ + "static/media/review-error-icon.93d1de2f07b92b7d3501a090fcc5732d.svg";
export { ForwardRef as ReactComponent };